export const GAM_SOURCE = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js'

// Space (px) reserved around a desktop GAM h5 interstitial so its wrapper's close button stays clickable.
export const DESKTOP_H5_CLOSE_BUTTON_GAP_PX = 160
